import { Typography } from "@platform/design-system";

export const CarrierRepsTab = (): React.JSX.Element => (
  <Typography variant="header-small" component="h2">
    Reps tab
  </Typography>
);
